// extracted by mini-css-extract-plugin
export var adBlock = "style-module--adBlock--f19b2";
export var theAd = "style-module--theAd--65cce";
export var title = "style-module--title--3aeef";